module.exports = __webpack_public_path__ + "img/logo-clearrealty-white.9bc737b0.svg";